import { STORE_RESTAURANTS_LIST } from "../actions";

export function restaurantsList(payload) {
  return {
    type: STORE_RESTAURANTS_LIST,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/restaurantsList.js